import React from 'react'
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from 'swiper/react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';

import {Autoplay,Navigation} from 'swiper/modules'
import { Education_Offers } from '../Data/E_Offer';
import Heading from './Heading';

const EducationOffer = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
  return (
    <motion.section 
            className="main-lwbl bg-[#F9FAFB] pt-16 px-[0.5rem] overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
         
      <Heading subHeading={"What We Offer"} heading={"A Structured Pathway  for Artistic Development"} 
      detail={"Education at LWBL is more than lectures or tutorials. It is a structured, supportive system that exposes artists to professional review, technical refinement, industry standards, and the deeper philosophies of visual storytelling. Every resource moves members one step closer to producing impactful, portfolio-ready work."}/>
  
      <div className='h-[100%] w-[100%] relative md:px-12 md:py-12
  lg:px-16 lg:py-16  px-2 py-16' >
     <button className="swiper-prev custom-nav"><IoIosArrowBack /></button>
  <button className="swiper-next custom-nav"><IoIosArrowForward /></button>

      <Swiper
        slidesPerView={1}
        spaceBetween={30}
       loop={true}
        autoplay={{
             delay:1500,
             disableOnInteraction: false,
        }}
        navigation={{
      prevEl: ".swiper-prev",
      nextEl: ".swiper-next",
    }}
        breakpoints={{
    576: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  }}
        modules={[Autoplay, Navigation]}
        className="mySwiper"
      >
        {Education_Offers.map((offer,index)=>(
        <SwiperSlide key={index}>
            <img src={offer.image} alt={offer.title} />
            <div className="mt-[1rem] flex flex-col gap-[0.5rem] justify-start items-start pl-2  text-[#000000]">
              <h4 className='font-cinzel text-xl font-normal'>{offer.title}</h4>
              <p className='font-outfit text-start font-light text-md '>{offer.description}</p>
            </div> 
        </SwiperSlide>
        ))}
        </Swiper>     
</div>

       </motion.section>
  )
}

export default EducationOffer
